import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export const VisualBreak1 = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Subtle parallax effect
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.6, 1, 0.6]);
  return <section ref={ref} className="relative h-[35vh] md:h-[50vh] w-full overflow-hidden bg-brand-dark" data-id="element-177">
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 w-full h-[130%] -top-[15%]" data-id="element-178">
        <img src="https://cdn.magicpatterns.com/uploads/43KQ18pUaeaDRRH3kfVWeb/IMG_2664-PROOF-THOMAS-MASOTTI.jpg" alt="Détail d'un traitement laser de détatouage sur la main" className="w-full h-full object-cover grayscale-[20%]" loading="lazy" data-id="element-179" />
      </motion.div>
    </section>;
};